module.exports = __webpack_public_path__ + "static/media/Up-arrow.af82d2a2.svg";